import { render, staticRenderFns } from "./TheStack.vue?vue&type=template&id=3b8c1cc2"
import script from "./TheStack.vue?vue&type=script&lang=js"
export * from "./TheStack.vue?vue&type=script&lang=js"
import style0 from "./TheStack.vue?vue&type=style&index=0&id=3b8c1cc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports